import { KText } from '@/ui-library/components/text';
import {
  Center,
  Flex,
  Icon,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Table,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid';
import { useState } from 'react';

export const OverviewCollapseWrapper = ({
  list = [],
  type = 'projects',
  columnsConfig = [],
  isCollapsed = true,
}) => {
  const [showAll, setShowAll] = useState(false);

  if (list?.length === 0)
    return (
      <KText variant="muted" color="secondary-700">
        The candidate isn’t a part of any {type}.
      </KText>
    );

  const windowWidth = window.innerWidth;

  return (
    <Flex
      flex="1"
      flexDir="column"
      overflowY={isCollapsed ? 'none' : 'scroll'}
      maxHeight={isCollapsed ? 'none' : '250px'}
    >
      <Table>
        <Thead className="records-table" bg="secondary-25">
          <Tr>
            {columnsConfig?.map?.((column, idx) => (
              <Th key={idx} py="16px">
                <KText
                  size="sm-semi-bold"
                  color="secondary-900"
                  textTransform="none"
                >
                  {column?.headerText}
                </KText>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody className="records-table">
          {list
            ?.slice(
              0,
              isCollapsed ? (showAll ? list?.length : 3) : list?.length
            )
            ?.map((item) => (
              <Tr key={item?.id}>
                {columnsConfig?.map((column, idx) => {
                  const { Cell = () => <></> } = column;
                  return (
                    <Td key={idx} minW={windowWidth > 1440 ? '300px' : '150px'}>
                      <Cell item={item} />
                    </Td>
                  );
                })}
              </Tr>
            ))}
        </Tbody>
      </Table>
      {list?.length > 3 && isCollapsed && (
        <Center
          p="21px 24px"
          cursor="pointer"
          onClick={() => setShowAll((prev) => !prev)}
          gap="4px"
        >
          <KText size="sm-medium">
            {showAll ? 'Collapse' : `Also part of`}
          </KText>
          <Text size="sm-medium" color="ats-primary">{`${
            list?.length - 3
          } other ${type}`}</Text>
          <Icon
            color="ats-primary"
            as={showAll ? ChevronUpIcon : ChevronDownIcon}
          />
        </Center>
      )}
    </Flex>
  );
};
